import { render, staticRenderFns } from "./ConfigSelectEgdsStrumentoView.vue?vue&type=template&id=98b2f610"
import script from "./ConfigSelectEgdsStrumentoView.vue?vue&type=script&lang=js"
export * from "./ConfigSelectEgdsStrumentoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports